import { create } from 'zustand';

type Screen = 'home' | 'quiz' | 'result' | 'leaderboard' | 'titlehall';

interface UIState {
  currentScreen: Screen;
  isNicknameModalOpen: boolean;
  nicknameCallback: (() => void) | null;
  streakToastText: string;
  streakToastVisible: boolean;
  isOffline: boolean;

  navigate: (screen: Screen) => void;
  openNicknameModal: (callback?: () => void) => void;
  closeNicknameModal: (skipCallback?: boolean) => void;
  showStreakToast: (text: string) => void;
  hideStreakToast: () => void;
  setOffline: (offline: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  currentScreen: 'home',
  isNicknameModalOpen: false,
  nicknameCallback: null,
  streakToastText: '',
  streakToastVisible: false,
  isOffline: !navigator.onLine,

  navigate: (screen) => set({ currentScreen: screen }),

  openNicknameModal: (callback) =>
    set({ isNicknameModalOpen: true, nicknameCallback: callback || null }),

  closeNicknameModal: (skipCallback = false) => {
    const cb = useUIStore.getState().nicknameCallback;
    set({ isNicknameModalOpen: false, nicknameCallback: null });
    if (!skipCallback && cb) cb();
  },

  showStreakToast: (text) => {
    set({ streakToastText: text, streakToastVisible: true });
    setTimeout(() => set({ streakToastVisible: false }), 2000);
  },

  hideStreakToast: () => set({ streakToastVisible: false }),
  setOffline: (offline) => set({ isOffline: offline }),
}));
